import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { installAuth } from 'features/auth';
import { installImpersonation } from 'features/impersonation';
import { routeTree } from 'routes/routeTree';
import { URL_PREFIX } from 'config';
import 'flag-icons/css/flag-icons.min.css';
import 'i18n';
import './styles.css';
const auth = installAuth();
installImpersonation(auth);
// `URL_PREFIX` from webpack ends with '/' when set (e.g. 'version-DEV/') and is
// empty in dev. TanStack Router's `basepath` expects a leading slash and no
// trailing slash (e.g. '/version-DEV'), so normalize before passing it through.
const basepath = URL_PREFIX ? `/${URL_PREFIX.replace(/\/+$/, '')}` : undefined;
const router = createRouter({
    routeTree,
    context: { auth },
    basepath,
});
// TanStack Router's `beforeLoad` only re-runs on route changes, not on auth store updates.
// When the auth status flips (sign-in succeeds, logout, token refresh flips to blocked, etc.)
// we need to invalidate the current match so the guards re-evaluate and redirect appropriately.
auth.subscribe(() => {
    void router.invalidate();
});
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            // Don't refire every active query when the browser tab regains focus.
            // Navigation still refreshes data via the default mount refetch.
            refetchOnWindowFocus: false,
            // Treat responses as fresh for a short window so quick back-and-forth
            // navigation (e.g. reopening the units popup) doesn't refetch immediately.
            staleTime: 30000,
        },
    },
});
const root = document.getElementById('application');
if (!root) {
    throw new Error('Missing #application root element');
}
createRoot(root).render(_jsx(QueryClientProvider, { client: queryClient, children: _jsx(RouterProvider, { router: router }) }));
